import React from 'react';
import { Link } from 'react-router-dom';
import { Hammer, Facebook } from 'lucide-react';
import { services, companyInfo } from '../data';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img 
                src="https://assets.auxodev.dk/assets/66803e0c-9723-4cfe-96f2-7ea52c9dabed/0c26ff57-dfcc-4fa5-8bf4-226445965a56.png" 
                alt="Nielsen Brolægning" 
                className="h-24 w-auto object-contain"
              />
            </Link>
            <p className="text-slate-400 mb-6">
              Din professionelle partner inden for brolægning og anlægsarbejde. Kvalitet og kundetilfredshed er mine kerneværdier.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Hurtige links</h4>
            <ul className="space-y-4 text-slate-400">
              <li><Link to="/" className="hover:text-orange-500 transition-colors">Forside</Link></li>
              <li><Link to="/om-os" className="hover:text-orange-500 transition-colors">Om mig</Link></li>
              <li><Link to="/kontakt" className="hover:text-orange-500 transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Ydelser</h4>
            <ul className="space-y-4 text-slate-400">
              {services.map((service) => (
                <li key={service.slug}>
                  <Link to={`/ydelser/${service.slug}`} className="hover:text-orange-500 transition-colors">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>


          <div>
            <h4 className="text-lg font-bold mb-6">Åbningstider</h4>
            <ul className="space-y-4 text-slate-400">
              <li className="flex justify-between">
                <span>Mandag - Torsdag:</span>
                <span>07:00 - 16:00</span>
              </li>
              <li className="flex justify-between">
                <span>Fredag:</span>
                <span>07:00 - 15:30</span>
              </li>
              <li className="flex justify-between">
                <span>Lørdag - Søndag:</span>
                <span>Lukket</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-slate-500 text-sm">
          <p>&copy; {new Date().getFullYear()} {companyInfo.name}. Alle rettigheder forbeholdes. CVR: {companyInfo.cvr}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
